<div class="bg-white">
  <h3 class="border-bottom p-4">
    <span *ngIf="editMode">{{ 'Sellers.Products.EditTeamMember' | translate }}</span>
    <span *ngIf="!editMode">{{ 'Sellers.Products.AddTeamMember' | translate }}</span>
  </h3>

  <form *ngIf="TeamMemberForm" [formGroup]="TeamMemberForm" class="p-4">
    <div class="form-group row">
      <div class="col-12 col-sm-6 mb-3">
        <label>{{ 'Sellers.Products.FirstName' | translate }}</label>
        <input type="text" [readonly]="editMode" formControlName="firstName"
               placeholder="{{ 'Sellers.Products.FirstName' | translate }}"
               class="form-control">
        <div class="text-danger" *ngIf="formValidator.formErrors.firstName">
          {{ formValidator.formErrors.firstName }}
        </div>
      </div>
      <div class="col-12 col-sm-6 mb-3">
        <label>{{ 'Sellers.Products.LastName' | translate }}</label>
        <input type="text" [readonly]="editMode" formControlName="lastName"
               placeholder="{{ 'Sellers.Products.LastName' | translate }}"
               class="form-control">
        <div class="text-danger" *ngIf="formValidator.formErrors.lastName">
          {{ formValidator.formErrors.lastName }}
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-12 col-sm-6 mb-3">
        <label>{{ 'Sellers.Products.Email' | translate }}</label>
        <input type="email" [readonly]="editMode" formControlName="email"
               placeholder="{{ 'Sellers.Products.Email' | translate }}"
               class="form-control">
        <div class="text-danger" *ngIf="formValidator.formErrors.email">
          {{ formValidator.formErrors.email }}
        </div>
      </div>
      <div class="col-12 col-sm-6 mb-3">
        <label>{{ 'Sellers.Products.TeamMemberRole' | translate }}</label>
        <select formControlName="roleId" class="form-select form-control" [(ngModel)]="selectedRole"
                (ngModelChange)="onRoleChange($event)">
          <option disabled value="null" selected>{{ 'Sellers.Products.TeamMemberRole' | translate }}</option>
          <option *ngFor="let role of roles" [value]="role.id">{{ role.name | translate}}</option>
        </select>
        <div class="text-danger" *ngIf="formValidator.formErrors.roleId">
          {{ formValidator.formErrors.roleId }}
        </div>
      </div>
      <mat-form-field class="col-12">
        <mat-label style="padding: 2px 7px;
        margin-top: -13px;
        background-color: #fff;
        margin-left: 7px;">{{'Organization' |translate}}</mat-label>
        <mat-select class="form-control" style="height: 46px;margin-top: -20px;" [formControl]="convertControls('businessIds')" multiple>
          <mat-option *ngFor="let d of orgData" [value]="d.id">{{ d.businessName }}</mat-option>
        </mat-select>
        <!-- <mat-error *ngIf="fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName]"> -->
        <!--     {{ fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName] }} -->
        <!-- </mat-error> -->
      </mat-form-field>
    </div>

    <ul class="list-group">
      <li class="list-group-item" *ngFor="let permission of rolePermissions">
        {{ permission.name }}
      </li>
    </ul>

    <mat-hint *ngIf="success" style="color:green">
      {{ 'Sellers.Products.AddeddSuccessfully' | translate }} <mat-icon>done</mat-icon>
    </mat-hint>
    <div class="d-flex justify-content-end">
      <button class="btn btn-primary" (click)="onSubmit()"
              *ngIf="TeamMemberForm" [disabled]="TeamMemberForm.invalid">
        {{ 'Sellers.Products.Submit' | translate }}
      </button>
    </div>
  </form>
</div>
